import { render } from "./CanceladosLiquidados.vue?vue&type=template&id=0db70d82&scoped=true"
import script from "./CanceladosLiquidados.vue?vue&type=script&lang=js"
export * from "./CanceladosLiquidados.vue?vue&type=script&lang=js"

import "./CanceladosLiquidados.vue?vue&type=style&index=0&id=0db70d82&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db70d82"]])

export default __exports__